// extracted by mini-css-extract-plugin
export var columnItem = "_4m-3";
export var columnItemDraggable = "_4m-4";
export var dragHandle = "_4m-0";
export var dragHandleHovered = "_4m-1";
export var dropdown = "_4m-5";
export var dropdownContent = "_4m-7";
export var dropdownInner = "_4m-6";
export var filterDropdownHeader = "_4m-8";
export var icon = "_4m-2";
export var sectionDivider = "_4m-9";